'use client';

import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from '../styles/Tokenomics.module.css';

gsap.registerPlugin(ScrollTrigger); // Register plugin outside component

const Tokenomics = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const cardsRef = useRef([]);

  // Token allocation data from the image
  const tokenAllocation = [
    { name: 'DEX Initial Liquidity Pool', percentage: '6%', amount: '125,000,000 GAM' },
    { name: 'Presale + Public Sale', percentage: '29%', amount: '583,272,727 GAM' },
    { name: 'Community rewards', percentage: '35%', amount: '700,000,000 GAM' },
    { name: 'Marketing Fund', percentage: '5%', amount: '91,727,273 GAM' },
    { name: 'Treasury-Business ops', percentage: '7%', amount: '100,000,000 GAM' },
    { name: 'Team and advisors', percentage: '18%', amount: '400,000,000 GAM' },
  ];

  useEffect(() => {
    // Create gsap context for scoping and automatic cleanup
    const ctx = gsap.context(() => {
      // Title animation
      if (titleRef.current) {
        gsap.fromTo(
          titleRef.current,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            scrollTrigger: {
              trigger: titleRef.current,
              start: 'top 80%',
              end: 'bottom 20%',
              toggleActions: 'play none none reverse',
            },
          }
        );
      }

      // Card animations with stagger effect
      if (cardsRef.current.length) {
        gsap.fromTo(
          cardsRef.current,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            stagger: 0.1,
            scrollTrigger: {
              trigger: cardsRef.current[0],
              start: 'top 80%',
              end: 'bottom 20%',
              toggleActions: 'play none none reverse',
            },
          }
        );
      }
    }, sectionRef); // Scope the context to the section element
    
    // Return ctx.revert() for automatic cleanup
    return () => ctx.revert();
  }, []);

  return (
    <section className={styles.tokenomics} id="tokenomics" ref={sectionRef}>
      <div className={styles.tokenomicsHeader}>
        <h2 className={styles.tokenomicsTitle} ref={titleRef}>Tokenomics</h2>
        <p className={styles.totalSupply}>
          Total Supply: <span className={styles.tokenAmount}>2,000,000,000 GAM</span>
        </p>
      </div>

      <div className={styles.tokenGrid}>
        {tokenAllocation.map((token, index) => (
          <div 
            key={index} 
            className={styles.tokenCard}
            ref={el => cardsRef.current[index] = el}
          >
            <p className={styles.tokenCardTitle}>{token.name}</p>
            <p className={styles.tokenPercentage}>{token.percentage}</p>
            <p className={styles.tokenAmount}>{token.amount}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Tokenomics; 